import { PlanStatus } from '@spectee/graphql/api';

export const planStatusLabel: Record<PlanStatus, string> = {
  noContract: '未契約',
  contract: '契約中',
  trial: 'トライアル中',
  sales: '営業用',
  test: 'テスト用',
  promotion: 'プロモーション用',
  preContract: '契約予定',
  cancel: '解約',
};
